import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import "typeface-roboto";
import { withStyles } from "@material-ui/core";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(25),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
});

class Beschikbaarheid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      beschikbaarheid: {
        morgen: {},
        middag: {},
        avond: {}
      },
      expanded: null
    };

    this.getValue = this.getValue.bind(this);
    this.renderShiftWeek = this.renderShiftWeek.bind(this);
    this.handleBlockClick = this.handleBlockClick.bind(this);
  }

  /**
   * Returns the value of this.state.beschikbaarheid
   */
  getValue() {
    return this.state.beschikbaarheid;
  }

  /**
   * Render a <td> with onClick handler and style based on `status`
   * @param {bool|null} status true=avail, false=unavail, undefined=not set
   */
  renderBlock(status, shift, day) {
    const styles = {
      available: { backgroundColor: "green" },
      unavailable: { backgroundColor: "orange" }
    };

    let style = status === true ? styles.available : styles.unavailable;

    Object.assign(style, {
      height: "50px",
      width: "100%",
      border: "1px solid rgb(122, 118, 53)"
    });

    return (
      <td key={Math.random()}>
        <div
          style={style}
          data-id={shift + "|" + day}
          onClick={this.handleBlockClick}
        >
          {/* */}
        </div>
      </td>
    );
  }

  renderShiftWeek(shift) {
    const { vrijwilliger } = this.props;
    const self = this;
    const week = [0, 1, 2, 3, 4, 5, 6, 7];
    return week.map((el, i) => {
      if (i === 0) {
        return (
          <td key={Math.random()} style={{ fontWeight: "700" }}>
            {shift}
          </td>
        );
      }
      shift = shift.toLowerCase();

      if (vrijwilliger.data.beschikbaarheid) {
        return self.renderBlock(
          vrijwilliger.data.beschikbaarheid[shift][i],
          shift,
          i
        );
      } else {
        return self.renderBlock(self.state.beschikbaarheid[shift][i], shift, i);
      }
    });
  }

  handleBlockClick(e) {
    const { vrijwilliger } = this.props;
    const self = this;
    const el = e.currentTarget.getAttribute("data-id");
    const shift = el.substr(0, el.indexOf("|"));
    const day = el.substr(el.indexOf("|") + 1, el.length);
    let beschikbaarheid = {};
    beschikbaarheid = vrijwilliger.data.beschikbaarheid
      ? vrijwilliger.data.beschikbaarheid
      : this.state.beschikbaarheid;
    Object.assign(beschikbaarheid, beschikbaarheid);
    beschikbaarheid[shift][day] = !beschikbaarheid[shift][day];

    this.setState(
      {
        beschikbaarheid: beschikbaarheid
      },
      () => {
        if (self.props.onChange) {
          self.props.onChange(beschikbaarheid);
        }
      }
    );

    vrijwilliger.update({
      beschikbaarheid: beschikbaarheid
    });
  }
  handlePanelChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render() {
    // const renderKey = () => {
    //   return <div style={{ width: "250px", padding: "0px" }} />;
    // };
    const { expanded } = this.state;
    const { classes } = this.props;
    const thStyle = {
      textAlign: "center",
      minWidth: "50px",
      maxWidth: "150px",
      fontSize: 12
    };

    return (
      <div>
        <ExpansionPanel
          expanded={expanded === "auto"}
          onChange={this.handlePanelChange("auto")}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" className={classes.heading}>
              Details van de beschikbaarheid
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <table style={{ width: "100%", textAlign: "center" }}>
              <tbody>
                <tr>
                  <th style={{ width: "100px" }}>{/* */}</th>
                  <th style={thStyle}>Maa</th>
                  <th style={thStyle}>Din</th>
                  <th style={thStyle}>Woe</th>
                  <th style={thStyle}>Don</th>
                  <th style={thStyle}>Vrij</th>
                  <th style={thStyle}>Zat</th>
                  <th style={thStyle}>Zon</th>
                </tr>
                <tr>{this.renderShiftWeek("Morgen")}</tr>
                <tr>{this.renderShiftWeek("Middag")}</tr>
                <tr>{this.renderShiftWeek("Avond")}</tr>
              </tbody>
            </table>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        {/* {renderKey()} */}
      </div>
    );
  }
}
export default withStyles(styles)(Beschikbaarheid);



// WEBPACK FOOTER //
// ./src/components/Vrijwilligers/Beschikbaarheid.jsx